/* AccordionItemTriggerContent.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import Badge from '@atlaskit/badge';
import Lozenge from '@atlaskit/lozenge';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { BodySmall } from '../Typography';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _6 = "._1bsb1osq{width:100%}";
const _5 = "._o5721q9c{white-space:nowrap}";
const _4 = "._1bto1l2s{text-overflow:ellipsis}";
const _3 = "._k48p1pd9{font-weight:var(--ds-font-weight-semibold,600)}";
const _2 = "._18m915vq{overflow-y:hidden}";
const _ = "._1reo15vq{overflow-x:hidden}";
const styles = xcss({
  flex: 1,
  width: '100%'
});
const accordionItemTriggerContentSpacing = xcss({
  flex: 1,
  padding: 'space.200'
});
const titleStyles = null;
const accordionTitleSectionStyles = xcss({
  width: '100%'
});
export const AccordionItemTriggerContent = _ref => {
  let {
    icon,
    title,
    count,
    showNewLozenge,
    testId,
    headingId = ''
  } = _ref;
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "space-between",
    xcss: accordionItemTriggerContentSpacing,
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      xcss: styles,
      testId: testId || 'accordion-item-trigger-content',
      children: [icon, /*#__PURE__*/_jsx(Box, {
        paddingInlineStart: "space.200",
        xcss: accordionTitleSectionStyles,
        children: /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_, _2, _3, _4, _5, _6]
          }), /*#__PURE__*/_jsx(BodySmall, {
            as: "h3",
            id: headingId,
            className: ax(["_1reo15vq _18m915vq _k48p1pd9 _1bto1l2s _o5721q9c _1bsb1osq"]),
            children: title
          })]
        })
      })]
    }), /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [count ? /*#__PURE__*/_jsx(Badge, {
        appearance: "default",
        children: count
      }) : null, showNewLozenge && /*#__PURE__*/_jsx(Lozenge, {
        appearance: "new",
        children: "New"
      })]
    })]
  });
};